var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import withTimeout from '../../util/timeout-promise';
import getServerConfig from '../../config/getServerConfig';
import buildAuthorizationUrl from '../../util/buildAuthorizationUrl';
const AUTH_CODE_IFRAME_TIMEOUT_MS = 1000;
const getAuthCodeViaIframe = (authorizeRequest) => __awaiter(void 0, void 0, void 0, function* () {
    let iframe = document.getElementById('authFrame');
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.setAttribute('width', '0');
        iframe.setAttribute('height', '0');
        document.body.appendChild(iframe);
    }
    const authCodeUrl = buildAuthorizationUrl(authorizeRequest);
    iframe.setAttribute('src', authCodeUrl);
    const { issuer } = getServerConfig();
    const authCodeRequest = new Promise((resolve, reject) => {
        window.addEventListener('message', evt => {
            if (evt.origin !== issuer)
                return;
            if (!evt.data.type)
                return;
            switch (evt.data.type) {
                case 'authorization_response': {
                    const source = evt.source;
                    if (source === null) {
                        return;
                    }
                    const response = evt.data.response;
                    if (authorizeRequest.state !== response.state) {
                        const error = {
                            error: 'unknown_error',
                            error_description: "State doesn't match. Malicious request",
                        };
                        reject(error);
                    }
                    resolve(response);
                    break;
                }
                default:
            }
        }, false);
    });
    return withTimeout(authCodeRequest, AUTH_CODE_IFRAME_TIMEOUT_MS, () => {
        const error = {
            error: 'login_required',
            error_description: 'Timeout when waiting for auth code from iframe',
        };
        return error;
    }).finally(() => {
        if (iframe && document.body.contains(iframe)) {
            document.body.removeChild(iframe);
        }
    });
});
export default getAuthCodeViaIframe;
//# sourceMappingURL=getAuthCodeViaIframe.js.map